import React from "react";
import PropTypes from "prop-types";
import { Grid, Toolbar, Paper, Typography, AppBar } from "@mui/material";
import PedidoTablaDetalle from "./EntradaMercanciaTablaDetalle";

function EntradaMercanciasDetalle(props) {
  return (
    <Paper sx={{ maxWidth: "90%", margin: "auto", overflow: "hidden" }}>
      <AppBar
        position="static"
        sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
      >
        <Toolbar>
          <Grid container spacing={2} alignItems="center">
            <Typography
              sx={{ flex: "1 1 100%" }}
              variant="h6"
              id="tableTitle"
              component="div"
            >
              Detalle de la entrada de mercancia
            </Typography>
          </Grid>
        </Toolbar>
        {
          <PedidoTablaDetalle
            rows={props.Entrada.DetalleEntradaMercancia}
            EncabezadoEntrada={props.Entrada}
          />
        }
      </AppBar>
    </Paper>
  );
}

EntradaMercanciasDetalle.propTypes = {
  Entrada: PropTypes.object,
};

export default EntradaMercanciasDetalle;
